import { metrics } from '@opentelemetry/api';
import type { Metric } from 'web-vitals';
import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

type MetricAttributes = Record<string, string | number | boolean>;

let webVitalsInitialized = false;

export function initializeWebVitals(baseAttributes: MetricAttributes): void {
  if (webVitalsInitialized || typeof window === 'undefined') {
    return;
  }

  webVitalsInitialized = true;

  const meter = metrics.getMeter('frontend-meter');

  const lcpHistogram = meter.createHistogram('frontend_cwv_lcp', {
    description: 'Largest Contentful Paint in milliseconds',
    unit: 'ms',
    advice: {
      explicitBucketBoundaries: [100, 500, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 10000],
    },
  });

  const fcpHistogram = meter.createHistogram('frontend_cwv_fcp', {
    description: 'First Contentful Paint in milliseconds',
    unit: 'ms',
    advice: {
      explicitBucketBoundaries: [100, 500, 1000, 1500, 1800, 2000, 3000, 5000],
    },
  });

  const ttfbHistogram = meter.createHistogram('frontend_cwv_ttfb', {
    description: 'Time to First Byte in milliseconds',
    unit: 'ms',
    advice: {
      explicitBucketBoundaries: [50, 100, 200, 400, 600, 800, 1000, 1500, 2000],
    },
  });

  const clsHistogram = meter.createHistogram('frontend_cwv_cls', {
    description: 'Cumulative Layout Shift score',
    advice: {
      explicitBucketBoundaries: [0.01, 0.05, 0.1, 0.15, 0.25, 0.5, 1.0],
    },
  });

  const inpHistogram = meter.createHistogram('frontend_cwv_inp', {
    description: 'Interaction to Next Paint in milliseconds',
    unit: 'ms',
    advice: {
      explicitBucketBoundaries: [25, 50, 100, 150, 200, 300, 500, 1000],
    },
  });

  const attrs = {
    ...baseAttributes,
    path: window.location.pathname,
  };

  onLCP((metric: Metric) => lcpHistogram.record(metric.value, attrs));
  onFCP((metric: Metric) => fcpHistogram.record(metric.value, attrs));
  onTTFB((metric: Metric) => ttfbHistogram.record(metric.value, attrs));
  onCLS((metric: Metric) => clsHistogram.record(metric.value, attrs));
  onINP((metric: Metric) => inpHistogram.record(metric.value, attrs));
}
